import "./Home.css";
import NavBar from "../NavBar";
import WishesByMonths from "../WishesByMonth";
import Footer from "../Footer";
import "bootstrap/dist/css/bootstrap.min.css";

function More() {
  return (
    <div className="Home">
      <NavBar />
      <div className="content">
        <WishesByMonths />
      </div>
      <Footer />
    </div>
  );
}

export default More;